import React from "react";
import {
    AccessDevicesTitle,
    IconKeyTitle
} from "../../../../../../../../components/buttons/IconButtons";
import SummaryListCard from "../../../../../../../../components/Summary/SummaryListCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Devices access container for the shift access summary. Thin wrapper over the
 * shared SummaryListCard with label-only rows.
 */
const SummaryContainerDevices = ({ t, selected = [] }) => {

    return (
        <SummaryListCard
            headerIcon={IconKeyTitle}
            title={t('devices_access')}
            emptyText={t('no_information_shift_access')}
            avatarIcon={AccessDevicesTitle}
            selected={selected}
            getLabel={(item) => item.fullName}
            overflowLabel={'total_added_devices'}
            t={t}
        />
    )

}

export default SummaryContainerDevices
